import { render, staticRenderFns } from "./produit_list.vue?vue&type=template&id=736569ec&scoped=true&"
import script from "./produit_list.vue?vue&type=script&lang=js&"
export * from "./produit_list.vue?vue&type=script&lang=js&"
import style0 from "./produit_list.vue?vue&type=style&index=0&id=736569ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736569ec",
  null
  
)

export default component.exports